import { AddCircle, ContactSupportOutlined } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import React, { createContext, useEffect, useState } from 'react'
import { ModalAgregaTipoActivoComponent } from '../../components/activos/ModalAgregaTipoActivoComponent'
import { ModalEliminaTipoActivoComponent } from '../../components/activos/ModalEliminaTipoActivoComponent'
import { TablaTiposActivo } from '../../components/activos/TablaTiposActivo'
import { ModalAgregaTipoServicioComponent } from '../../components/servicios/ModalAgregaTipoServicioComponent'
import { ModalEliminaTipoServicioComponent } from '../../components/servicios/ModalEliminaTipoServicioComponent'
import { TablaTiposServicio } from '../../components/servicios/TablaTiposServicio'
import { ObtenerTiposActivo } from '../../helpers/ActivosHelper'
import { ObtenerTiposServicio } from '../../helpers/ServiciosHelper'

export const TiposServicioContext = createContext();
export const ServiciosTipoPage = () => {
  const [tiposServicio, setTiposServicio] = useState();
  const [modalAgregaTipoServicio, setModalAgregaTipoServicio] = useState(false);
  const [modalEliminaTipoServicio, setModalEliminaTipoServicio] = useState(false);
  const [tipoServicioSel, setTipoServicioSel] = useState();

  useEffect(() => {
    obtenerTipos();
  }, [])

  const obtenerTipos =() => {
    ObtenerTiposServicio().then(datos=>setTiposServicio(datos))

  }
  
  useEffect(() => {
    console.log('Tipos de activo', tiposServicio)
  }, [tiposServicio])
  

  return (
    <TiposServicioContext.Provider value={{modalAgregaTipoServicio, setModalAgregaTipoServicio,obtenerTipos,
      modalEliminaTipoServicio, setModalEliminaTipoServicio, tipoServicioSel, setTipoServicioSel
    }}>
    <div
        style={{
          display:'flex',
          flexDirection:'column',
          flex:1,
            color:'black',
            marginTop:10,
            marginLeft:40,
            marginRight:20
        }}
    >
      <div
        style={{
          display:'flex',
          flexDirection:'row',
          justifyContent:'space-between',
          maxWidth:700
        }}
      >

        <span
            style={{
              fontSize:40,
              fontWeight:'bold'
            }}
            >
            Tipos de Servicio
        </span>
        <span
          style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center'
          }}
        >
          <IconButton
            onClick={() => {setTipoServicioSel(); setModalAgregaTipoServicio(true)}}
          >
            <AddCircle style={{color:'#60318A'}} color="#60318A" />
            Agregar
          </IconButton>
        </span>
      </div>
        <div
            style={{
            fontSize:28,
            fontWeight:'regular',
            marginLeft:10,
            maxWidth:900,
            backgroundColor:'transparent',
            flex:1
            }}
        >
          <TablaTiposServicio tiposServicio={tiposServicio} />
        </div>
    </div>   
    <ModalAgregaTipoServicioComponent />
    <ModalEliminaTipoServicioComponent />
    </TiposServicioContext.Provider> 
  )
}
